export default {
  'page.store': '商家',
  'module.store': '商家',
  'module.store-member': '商家管理員',
  'manage-store.form_block': '管理的商家',

  // data
  'store.data.name': "商家名稱",

  // form
  'store-member.form_block': '商家管理員',

  // others
  'store.search_keyword': '輸入商家名稱搜尋',
  'store-member.search_keyword': '輸入會員名稱搜尋',
}
